import { List, Modal } from "antd";
import { Link } from "react-router-dom";
import "./OwnersModal.css";
import { useMobxStores } from "../../../stores/stores";

const OwnersModal = ({ isOpen, handleClose }) => {
  const { marketplaceStore } = useMobxStores();

  return (
    <Modal
      // className="custom-modal"
      open={isOpen}
      onCancel={handleClose}
      footer={null}
      width={540}
      styles={{
        body: { maxHeight: "400px", overflowY: "auto" },
      }}
      title={
        <span style={{ color: "#000080", fontWeight: "600", fontSize: "20px" }}>
          Owned by
        </span>
      }
    >
      <div className="custom-scrollable">
        <List
          dataSource={marketplaceStore.ownership}
          renderItem={(item) => (
            <div key={item.id} style={{ display: "flex", gap: "12px" }}>
              <Link className="custom-link">@{item.owner_username}</Link>
              <span>
                {item.quantity} {item.quantity > 1 ? "editions" : "edition"}
              </span>
            </div>
          )}
        />
      </div>
    </Modal>
  );
};

export { OwnersModal };
